import moment from 'moment'

export const formatDate: (date: string) => string = (date: string): string  => {
  const formatedDate: moment.Moment = moment(date)
  formatedDate.local()
  return formatedDate.format('dddd, DD-MM-YYYY, HH:mm:ss')
}

